import { AbilityBuilder, PureAbility } from '@casl/ability';
import { UserRole } from 'enums/user';
import { getRolePermissions } from './rolePermissions';

export interface Permissions {
  action: string;
  subject: string;
}

export const ability = new PureAbility<[string, string]>();

export function updateAbility(permissions: Permissions[]): void {
  const { can, rules } = new AbilityBuilder(PureAbility<[string, string]>);
  for (const perm of permissions) {
    can(perm.action, perm.subject);
  }
  ability.update(rules);
}

export function updateAbilityFromRole(role: UserRole): void {
  updateAbility(getRolePermissions(role));
}
